/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Queuecount1Inputs */

const en_entity_queuecount1 = /** @type {(inputs: Entity_Queuecount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queue Count`)
};

const de_entity_queuecount1 = /** @type {(inputs: Entity_Queuecount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Queues`)
};

/**
* | output |
* | --- |
* | "Queue Count" |
*
* @param {Entity_Queuecount1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_queuecount1 = /** @type {((inputs?: Entity_Queuecount1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Queuecount1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_queuecount1(inputs)
	return de_entity_queuecount1(inputs)
});
export { entity_queuecount1 as "entity_queueCount" }